'use client';

import { Grid, Icon, type IconNames, TextField, TextPassage } from '@petsmart-ui/sparky';
import { useFormikContext } from 'formik';

import { type AccountPaymentsSuccessResponse, getCreditCardIcon } from '@libs/common-next';

import type { PaymentFormInterface } from './types';
import { handleSetExpirationDate } from './utils';

export function CardDetailsInputs({ cardData }: { readonly cardData: AccountPaymentsSuccessResponse }) {
    const { values, touched, errors, handleChange, handleBlur, setFieldValue } =
        useFormikContext<PaymentFormInterface>();

    const { cardType, lastFour } = cardData;

    const cardIcon = getCreditCardIcon(cardType) as IconNames;

    return (
        <Grid gap="sm" className="payment-form__edit-form sparky-u-margin-bottom-sm" data-testid="edit-payment-form">
            <Grid.Item>
                <div
                    className="payment-form__edit-form--card-info"
                    data-testid="edit-payment-form-card-info"
                    data-cs-mask
                >
                    <Icon name={cardIcon} size="3xl" data-testid="card-icon" />
                    <TextPassage>
                        <span className="card-name" data-testid="card-name">{`${cardType} ••••${lastFour}`}</span>
                    </TextPassage>
                </div>
            </Grid.Item>
            <Grid.Item>
                <TextField
                    data-cs-mask
                    data-testid="expiration-date"
                    id="expirationDate"
                    label="Exp MM/YY"
                    name="expirationDate"
                    maxLength={5}
                    type="text"
                    value={values.expirationDate}
                    required
                    onChange={e => {
                        handleSetExpirationDate(e, setFieldValue);
                    }}
                    onBlur={handleBlur}
                    isError={touched.expirationDate && !!errors.expirationDate}
                    fieldNote={touched.expirationDate && errors?.expirationDate?.[0]}
                />
            </Grid.Item>
            <Grid.Item>
                <TextField
                    data-cs-mask
                    data-testid="name-on-card"
                    id="nameOnCard"
                    label="Name on card"
                    name="nameOnCard"
                    type="text"
                    value={values.nameOnCard}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    isError={touched.nameOnCard && !!errors.nameOnCard}
                    fieldNote={touched.nameOnCard && errors?.nameOnCard?.[0]}
                    maxLength={30}
                />
            </Grid.Item>
        </Grid>
    );
}
